import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cmd-dialog m-float" }
const _hoisted_2 = { class: "cmd-header" }
const _hoisted_3 = {
  class: "cmd-body",
  ref: "listRef"
}
const _hoisted_4 = {
  key: 0,
  class: "cmd-empty"
}
const _hoisted_5 = { class: "cmd-group-title" }
const _hoisted_6 = ["onClick", "onMouseenter"]
const _hoisted_7 = { class: "cmd-item-icon" }
const _hoisted_8 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_9 = {
  key: 2,
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_10 = { class: "cmd-item-info" }
const _hoisted_11 = { class: "cmd-item-title" }
const _hoisted_12 = {
  key: 0,
  class: "cmd-item-sub"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cmd-overlay",
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                class: "cmd-icon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2"
              }, [
                _createElementVNode("circle", {
                  cx: "11",
                  cy: "11",
                  r: "8"
                }),
                _createElementVNode("line", {
                  x1: "21",
                  y1: "21",
                  x2: "16.65",
                  y2: "16.65"
                })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                ref: "inputRef",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                class: "cmd-input",
                placeholder: "搜索页面、常用指令或输入关键词... (Esc 退出)",
                onKeydown: [
                  _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.move(1)), ["prevent"]), ["down"])),
                  _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.move(-1)), ["prevent"]), ["up"])),
                  _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.selectCurrent && _ctx.selectCurrent(...args)), ["prevent"]), ["enter"])),
                  _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]), ["esc"]))
                ]
              }, null, 544), [
                [_vModelText, _ctx.keyword]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "cmd-esc-tip" }, "ESC", -1))
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.filteredEntries.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 未找到匹配项 "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedEntries, (group, gIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: group.name,
                  class: "cmd-group"
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(group.name), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.key,
                      class: _normalizeClass(['cmd-item', { 'is-active': item.globalIndex === _ctx.activeIndex }]),
                      onClick: ($event: any) => (_ctx.runItem(item)),
                      onMouseenter: ($event: any) => (_ctx.activeIndex = item.globalIndex)
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        (item.icon && item.icon.startsWith('icon-'))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(['iconfont', item.icon])
                            }, null, 2))
                          : (item.type === 'action')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("polygon", { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2" }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[9] || (_cache[9] = [
                                _createElementVNode("rect", {
                                  x: "3",
                                  y: "3",
                                  width: "7",
                                  height: "7"
                                }, null, -1),
                                _createElementVNode("rect", {
                                  x: "14",
                                  y: "3",
                                  width: "7",
                                  height: "7"
                                }, null, -1),
                                _createElementVNode("rect", {
                                  x: "14",
                                  y: "14",
                                  width: "7",
                                  height: "7"
                                }, null, -1),
                                _createElementVNode("rect", {
                                  x: "3",
                                  y: "14",
                                  width: "7",
                                  height: "7"
                                }, null, -1)
                              ]))]))
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(item.title), 1),
                        (item.sub)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.sub), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "cmd-item-enter" }, "↵", -1))
                    ], 42, _hoisted_6))
                  }), 128))
                ]))
              }), 128))
            ], 512),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "cmd-footer" }, [
              _createElementVNode("span", null, [
                _createElementVNode("kbd", null, "↑"),
                _createTextVNode(),
                _createElementVNode("kbd", null, "↓"),
                _createTextVNode(" 导航")
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("kbd", null, "↵"),
                _createTextVNode(" 跳转 / 执行")
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("kbd", null, "ESC"),
                _createTextVNode(" 关闭")
              ])
            ], -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}